module.exports = __webpack_public_path__ + "static/media/landing-banner.b71d4d5b.png";